/**
 * Service for managing debug mode state
 * When enabled, adds Debug=true to API calls
 */

class DebugService {
    private static readonly STORAGE_KEY = 'api_debug_enabled';
    private listeners: Set<() => void> = new Set();
    private enabled: boolean = false;

    constructor() {
        // Load from sessionStorage on initialization
        const stored = sessionStorage.getItem(DebugService.STORAGE_KEY);
        this.enabled = stored === 'true';
    }

    /**
     * Check if debug mode is enabled
     */
    isEnabled(): boolean {
        return this.enabled;
    }

    /**
     * Enable debug mode
     */
    enable(): void {
        this.enabled = true;
        sessionStorage.setItem(DebugService.STORAGE_KEY, 'true');
        this.notifyListeners();
    }

    /**
     * Disable debug mode
     */
    disable(): void {
        this.enabled = false;
        sessionStorage.setItem(DebugService.STORAGE_KEY, 'false');
        this.notifyListeners();
    }

    /**
     * Toggle debug mode
     */
    toggle(): void {
        if (this.enabled) {
            this.disable();
        } else {
            this.enable();
        }
    }

    /**
     * Subscribe to debug mode changes
     */
    subscribe(listener: () => void): () => void {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }

    private notifyListeners(): void {
        this.listeners.forEach(listener => listener());
    }
}

// Export singleton instance
export const debugService = new DebugService();
